import React from 'react';

import { useField } from 'react-final-form';

import { Field } from '@atlaskit/form';

import { CsvDropzoneWithFiles } from '@qality/common-components';

type Props = {
  label: string;
  name: string;
  isRequired: boolean;
};

function CsvDropzoneWithFilesField({
  label,
  name,
  isRequired,
}: Props): JSX.Element {
  const { input } = useField(name);
  const { input: delimiter } = useField('delimiter');
  const { input: encoding } = useField('encoding');

  return (
    <Field name={name} label={label} isRequired={isRequired}>
      {() => (
        <CsvDropzoneWithFiles
          file={input.value}
          onChange={input.onChange}
          onDelimiterChange={delimiter.onChange}
          onEncodingChange={encoding.onChange}
        />
      )}
    </Field>
  );
}

export default CsvDropzoneWithFilesField;
